import React from "react";
import { ListItem } from "./modules/ListItem/ListItem";

export const Checklist = ({ list }) => {
  return (
    <div className="d-flex flex-column tw-gap-4">
      {list.map((item) => (
        <ListItem key={item.label} {...item} />
      ))}
    </div>
  );
};
